export default "__VITE_ASSET__DwkEHzga__"